<template>
	<report-page
		ref="page"
		:start-date="true"
		:end-date="true"
		get-url="/bo/report/finance/transactionfees"
		title="Transaction Fees Report"
		export-filename="transaction-fees"
		:show="true"
	>
		<template #item.transactionId="{ item }">
			<a :href="`/bo/transactions/view?id=${item.transactionId}`">
				{{ item.transactionId }}
			</a>
		</template>
		<template #item.transactionUrl="{ item }">
			<a :href="item.transactionUrl">
				<translate>
					Link
				</translate>
			</a>
		</template>
	</report-page>
</template>

<script>
import ReportPage from '../../../../../organisms/ReportPage.vue';

export default {
	name: 'TransactionsReport',
	components: {
		ReportPage
	}
};
</script>
